import React, { useEffect, useRef } from "react"
import * as S from "./statistics-item.styles"
import { useCountUp } from "react-countup"
import { Grid } from "@mui/material"

const StatisticsItem = ({ text, number, beforeIcon, afterIcon }) => {
  const countUpRef = useRef(null)
  const { start, reset } = useCountUp({
    ref: countUpRef,
    start: 0,
    end: +number,
    delay: 1000,
    duration: 2,
    enableScrollSpy: true,
    useEasing: false,
  })

  useEffect(() => {
    start()
    return () => {
      reset()
    }
  }, [])

  if (!text || !number) return null
  return (
    <Grid item xs={12} md={4}>
      <S.StatisticsItem>
        <S.StatisticsDescription>{text}</S.StatisticsDescription>
        <S.ValueContainer>
          {beforeIcon}
          <S.StatisticsNumber className="number" ref={countUpRef} />
          {afterIcon}
        </S.ValueContainer>
      </S.StatisticsItem>
    </Grid>
  )
}

export default StatisticsItem
